import React, { useState } from 'react';
import ActionButton from '../ActionButton';
import ButtonBadge from '../ButtonBadge';
import SplitButton from '../SplitButton';

export default function BulkActionMenu({ children, count = 0 }) {
  const [isOpen, setIsOpen] = useState();

  return (
    <SplitButton>
      <ActionButton disabled={count === 0} onClick={() => setIsOpen(true)}>
        Bulk Actions <ButtonBadge>{count}</ButtonBadge>
      </ActionButton>
      <SplitButton.Menu position="top" onClose={() => setIsOpen(false)} isOpen={isOpen} onClick={() => setIsOpen(true)}>
        {typeof children === 'function' ? children({ setIsOpen }) : children}
      </SplitButton.Menu>
    </SplitButton>
  );
}

BulkActionMenu.Item = SplitButton.Item;
